import { getGlobalParams, getShopInfo, getContractorInfo } from '@/utils/bridge/bridge.js'
import store from '@/store'
import bridgeInit from '@didi/sailing-bridge'
import {
  isWhiteNameForShare,
  getContractor,
  getShopByID,
  getDefaultGlobalParams,
} from '@/utils/passport/h5passport.js'
import { getQueryObj } from '@/utils/common/query.js'
import { isFromBDAPP, setFromBDAPPGlobalConfig } from '@/utils/bridge/fromBDAPP'
import { isDebug } from '@/utils/common/env.js'
import { passportLogin } from '@/utils/passport/login.js'
import { getLocale, getLanguage } from '@/utils/common/locale.js'

function getBridgeInfo(pathName) {
  // 直接展示 白名单
  const whiteNameArr = [
    '/sob/invite-code',
    '/deeplink',
    '/download/bd-app',
    '/confirmation-entrega',
    '/confirmation-entrega/locator',
    '/confirmation-entrega/delivery-code',
    '/confirmation-entrega/completed',
    '/delivery-worker-verify',
  ]
  return new Promise((resolve, reject) => {
    const isWhiteName = whiteNameArr.some(item => {
      return pathName.indexOf(item) > -1
    })
    if (isWhiteName) {
      // 为白名单页面提供默认公参，确保 lang 等参数能正确传递
      const defaultParams = {
        lang: getLanguage().long, // 确保有默认的 lang 参数
        locale: getLocale(),
      }
      store.commit('UPDATE_GLOBAL_PARAMS', defaultParams)
      resolve()
    } else if (isWhiteNameForShare()) {
      // 在passport登录的白名单内
      const { shopId, contractorId, country, cityId } = getQueryObj()
      store.commit('UPDATE_CURRENT_COUNTRY', country)
      store.commit(
        'UPDATE_GLOBAL_PARAMS',
        getDefaultGlobalParams({
          shopId,
          contractorId,
          cityId,
          countryCode: country,
        }),
      )
      Promise.all([getContractor(), getShopByID()]).then(([shopContractor, currentShopInfo]) => {
        store.commit('UPDATE_CURRENT_CONTRACTOR', shopContractor)
        store.commit('UPDATE_CURRENT_SHOP', currentShopInfo.data)
        resolve()
      })
    } else if (isFromBDAPP()) {
      // 判断是否从BDAPP中跳转过来
      setFromBDAPPGlobalConfig(resolve)
    } else {
      try {
        Promise.all([getGlobalParams(), getShopInfo(), getContractorInfo()])
          .then(([globalParams, shopInfo, contractorInfo]) => {
            const shopBusinessType = shopInfo.shopBusinessType
              ? shopInfo.shopBusinessType === -1
                ? 1
                : shopInfo.shopBusinessType
              : 1
            // 初始化bridge监控
            bridgeInit({
              module: 'bH5',
              Omega: window.Omega,
              params: globalParams,
              options: { showLog: true },
            })
            store.commit('UPDATE_GLOBAL_PARAMS', {
              ...globalParams,
              shopBusinessType,
            })
            store.commit('UPDATE_CURRENT_SHOP', {
              ...shopInfo,
              businessType: shopBusinessType,
            })
            store.commit('UPDATE_CURRENT_COUNTRY', shopInfo && shopInfo.countryCode)
            store.commit('UPDATE_CURRENT_CONTRACTOR', contractorInfo)
            resolve()
          })
          .catch(e => {
            console.log('init error', e)
            if (isDebug) {
              passportLogin(resolve)
            }
          })
      } catch (error) {
        console.log(error)
        if (isDebug) {
          passportLogin(resolve)
        }
      }
    }
  })
}

export function init() {
  const pathName = window ? window.location.pathname : ''
  return getBridgeInfo(pathName)
}
